import React, { useEffect, useState } from 'react';
import SearchInput from '../../components/search/SearchInput';
import MCollapse from '../../components/common/m-collapse/MCollapse';
import MCheckbox from '../../components/common/m-checkbox/MCheckbox';
import SearchItem from '../../components/search/SearchItem';
import { useTranslation } from 'react-i18next';
import { useGetListMutation } from '../../api/LibraryApi/LibraryService';
import {
    gradeOptions,
    initialSearchFilters,
    subjectsOptions,
} from '../../models/library';
import {setIsError} from "../../store/reducers/notificationSlice";
import { useDispatch, useSelector } from 'react-redux';

function Search(props) {
    const [books, setBooks] = useState([]);
    const [filters, setFilters] = useState(initialSearchFilters);
    const [grades, setGrades] = useState(gradeOptions);
    const [subjects, setSubjects] = useState(subjectsOptions);
    const [firstTime, setFirstTime] = useState(true)
    const dispatch = useDispatch()
    const isAuth = useSelector(store=>store.auth.isAuth)
    const activeRole = useSelector(store=>store.user.activeRole);
    const username = useSelector(store=>store.user.username);

    const { t } = useTranslation();

    const [ getList ] = useGetListMutation()

    const reformatParams = (data)  => {
        let filterStr = '?';
        for (const [key, value] of Object.entries(data)) {
            if (value) {
                if (key === 'grade' || key === 'subject') {
                    data[key].forEach(val => {
                        filterStr = filterStr + `&${key}=${val}`
                    })
                } else {
                    if (filterStr === '?') {
                        filterStr = filterStr + `${key}=${value}`
                    } else {
                        filterStr = filterStr + `&${key}=${value}`
                    }
                }
            }
        }
        return filterStr;
    }

    const onSearch = async (subject) => {
        if (isAuth) {
            const params = reformatParams(subject ? {...filters, subject: [ subject], username, role: activeRole } : {...filters, username, role: activeRole})
            if (subject) {
                setFilters({...filters, subject: [ subject ]})
            }
            const { data, error } = await getList(params);
            firstTime && setFirstTime(false);
            if (data && data.books) {
                setBooks(data.books)
            }
            if(error){
                dispatch(setIsError(t(`general.models.serverErrors.library.${error.status}`)))
            }
            setFilter('');
        }
    }

    const setFilter = (value) => {
        setFilters({...filters, input_text: value});
    }

    return (
        <div className="tablet:pr-6">
            <SearchInput
                setSearch={onSearch}
                onChange={setFilter}
                value={filters.input_text}
            />
            {
                !firstTime
                    && (
                        <>
                            <div className="w-full p-6 tablet:hidden">
                                <div className="border border-[#0000001A] rounded-lg p-4">
                                    <MCollapse title={t('searchPage.result.Class')}>
                                        {grades.map(grade => {
                                            return (
                                                <MCheckbox
                                                    label={t(`libraryPage.filters.grade.${grade.value}`)}
                                                    key={grade.value}
                                                    value={grade.checked}
                                                    setValue={() => {
                                                        setGrades(grades.map(item => {
                                                            if (item.value === grade.value) {
                                                                return {...item, checked: !item.checked}
                                                            } else {
                                                                return item
                                                            }
                                                        }))
                                                        setFilters({...filters, grade: !grade.checked ? [...filters.grade, grade.value] : filters.grade.filter(item => item !== grade.value)});
                                                    }
                                                    }
                                                />
                                            )
                                        })
                                        }
                                    </MCollapse>
                                    <MCollapse title={t('searchPage.result.subject')}>
                                        {
                                            subjects.sort(
                                                (a, b) => {
                                                    let nameA = t(`libraryPage.filters.subject.${a.value}`)
                                                    let nameB = t(`libraryPage.filters.subject.${b.value}`)
                                                    return nameA.localeCompare(nameB);
                                                }).map(subject => {
                                                return (
                                                    <div key={subject.value}>
                                                        <MCheckbox
                                                            label={t(`libraryPage.filters.subject.${subject.value}`)}
                                                            value={subject.checked}
                                                            setValue={() => {
                                                                setSubjects(subjects.map(item => {
                                                                    if (item.name[filters.publication_language] === subject.name[filters.publication_language]) {
                                                                        return {...item, checked: !item.checked}
                                                                    } else {
                                                                        return item
                                                                    }
                                                                }))
                                                                setFilters({...filters, subject: !subject.checked ? [...filters.subject, subject.name[filters.publication_language]] : filters.subject.filter(item => item !== subject.name[filters.publication_language])});
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                )
                                            })
                                        }
                                    </MCollapse>
                                </div>
                                <div className="my-4">
                                    <h3 className="text-2xl mb-4">{t('searchPage.result.found')} {books.length}</h3>
                                    <ol>
                                        {books.map((item, index) => {
                                            return (
                                                <SearchItem
                                                    key={item.name}
                                                    index={index + 1}
                                                    title={item.name}
                                                    publishingHouse={item.publisher}
                                                    grade={item.grade}
                                                    subject={item.subject}
                                                />
                                            )
                                        })}
                                    </ol>
                                </div>
                            </div>
                            <div className="w-full p-6 hidden tablet:flex tablet:flex-col desktop:flex-row">
                                <div className="border border-[#0000001A] rounded-lg p-4 flex flex-col tablet:w-full desktop:w-1/3 desktop:order-2">
                                    <div>
                                        <h3 className="font-bold py-2 ">{t('searchPage.result.Class')}</h3>
                                        <div className="flex flex-wrap">
                                            {grades.map(grade => {
                                                return (
                                                    <div key={grade.value}>
                                                        <MCheckbox
                                                            label={t(`libraryPage.filters.grade.${grade.value}`)}
                                                            value={grade.checked}
                                                            setValue={() => {
                                                                setGrades(grades.map(item => {
                                                                    if (item.value === grade.value) {
                                                                        return {...item, checked: !item.checked}
                                                                    } else {
                                                                        return item
                                                                    }
                                                                }))
                                                                setFilters({...filters, grade: !grade.checked ? [...filters.grade, grade.value] : filters.grade.filter(item => item !== grade.value)});
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                )
                                            })
                                            }
                                        </div>
                                    </div>
                                    <div>
                                        <h3 className="font-bold py-2">{t('searchPage.result.subject')}</h3>
                                        <div className="flex flex-wrap">
                                            {
                                                subjects.map(subject => {
                                                    return (
                                                        <div key={subject.value}>
                                                            <MCheckbox
                                                                label={t(`libraryPage.filters.subject.${subject.value}`)}
                                                                value={subject.checked}
                                                                setValue={() => {
                                                                    setSubjects(subjects.map(item => {
                                                                        if (item.value === subject.value) {
                                                                            return {...item, checked: !item.checked}
                                                                        } else {
                                                                            return item
                                                                        }
                                                                    }))
                                                                    setFilters({...filters, subject: !subject.checked ? [...filters.subject, subject.value] : filters.subject.filter(item => item !== subject.value)});
                                                                }
                                                                }
                                                            />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="my-4 desktop:w-2/3 desktop:order-1">
                                    <h3 className="text-2xl mb-4">{t('searchPage.result.found')} {books.length}</h3>
                                    <ol>
                                        {books.map((item, index) => {
                                            return (
                                                <SearchItem
                                                    key={item.value}
                                                    index={index + 1}
                                                    title={item.name}
                                                    publishingHouse={item.publisher}
                                                    grade={item.grade}
                                                    subject={item.subject}
                                                    id={item.book_id}
                                                />
                                            )
                                        })}
                                    </ol>
                                </div>
                            </div>
                        </>
                    )
            }

        </div>
    );
}

export default Search;
